import { X, Goal } from "lucide-react"

interface ChallengeFeedbackHeaderProps {
  onClose: () => void
}

export default function ChallengeFeedbackHeader({ onClose }: ChallengeFeedbackHeaderProps) {
  return (
    <div className="mb-5 flex h-fit w-full items-start justify-between">
      <span></span>

      <div className="flex flex-col items-center justify-center gap-2 pl-[16px]">
        <h2 className="text-lg font-bold">Resumen</h2>
        <div className="flex items-center justify-center gap-2 rounded-lg border border-primary-500 px-2 py-1 text-primary-500">
          <span className="text-[14px] font-medium">Desafíos</span>
          <Goal className="!size-4" />
        </div>
      </div>

      <div className="w-fit">
        <X className="cursor-pointer text-neutral-500 hover:text-neutral-700" onClick={onClose} />
      </div>
    </div>
  )
}
